
// 国际化迁移：所有 UI 文本统一用 t('admin.xxx') 或 texts.admin.xxx 代理调用
// 用法示例：t(`admin.${ORDER_STATUS_LABELS.paid}`) 或 texts.admin[ORDER_STATUS_LABELS.paid]
export const ORDER_STATUS_LABELS = {
  paid: 'orderStatusPaid',
  packed: 'orderStatusPacked',
  in_transit: 'orderStatusInTransit',
  delivered: 'orderStatusDelivered',
  cancelled: 'orderStatusCancelled'
};

export const ADMIN_TAB_DESCRIPTIONS = {
  home: 'tabDescHome',
  storeBase: 'tabDescStoreBase',
  templateStudio: 'tabDescTemplateStudio',
  articleManagement: 'tabDescArticleManagement',
  companyImages: 'tabDescCompanyImages',
  designNav: 'tabDescDesignNav',
  designCarousel: 'tabDescDesignBanner',
  faqKnowledge: 'tabDescFaqKnowledge',
  products: 'tabDescProducts',
  productCreate: 'tabDescProductCreate',
  merchandising: 'tabDescMerchandising',
  procurement: 'tabDescProcurement',
  quality: 'tabDescQuality',
  logistics: 'tabDescLogistics',
  orders: 'tabDescOrders',
  customers: 'tabDescCustomers',
  marketing: 'tabDescMarketing',
  discounts: 'tabDescDiscounts',
  finance: 'tabDescFinance',
  financeIncome: 'tabDescFinanceIncome',
  financeExpenses: 'tabDescFinanceExpenses',
  financeReceivables: 'tabDescFinanceReceivables',
  financePayables: 'tabDescFinancePayables',
  financeInvoices: 'tabDescFinanceInvoices',
  financeTax: 'tabDescFinanceTax',
  financeBudget: 'tabDescFinanceBudget',
  financeDaily: 'tabDescFinanceDaily',
  financeMonthly: 'tabDescFinanceMonthly',
  financeYearly: 'tabDescFinanceYearly',
  financeReconciliation: 'tabDescFinanceReconciliation',
  financeApprovals: 'tabDescFinanceApprovals',
  financeReports: 'tabDescFinanceReports',
  analytics: 'tabDescAnalytics',
  settings: 'tabDescSettings',
  workTargets: 'tabDescWorkTargets',
  workProcessing: 'tabDescWorkProcessing',
  hrEmployee: 'tabDescHrEmployee',
  hrRecruitment: 'tabDescHrRecruitment',
  hrAttendance: 'tabDescHrAttendance',
  hrOffice: 'tabDescHrOffice',
  siteMaintenance: 'tabDescSiteMaintenance',
  permissionMaintenance: 'tabDescPermissionMaintenance',
  positionMaintenance: 'tabDescPositionMaintenance',
  profile: 'tabDescProfile',
  password: 'tabDescPassword',
  inquiry: 'tabDescInquiry',
  wishlist: 'tabDescWishlist',
  orderProcessing: 'tabDescOrderProcessing',
  afterSales: 'tabDescAfterSales'
};

export const ROLE_LABELS = {
  developer: 'roleDeveloper',
  'super-admin': 'roleSuperAdmin',
  admin: 'roleAdmin',
  customer: 'roleCustomer',
  guest: 'roleGuest'
};

// 权限 label 统一用 t(`admin.capability.${key}`) 或 texts.admin.capability[key]
export const CAPABILITY_LABELS = [
  "admin:overview:read",
  "admin:products:read",
  "admin:products:write",
  "admin:orders:read",
  "admin:orders:write",
  "admin:users:read",
  "admin:users:role:write",
  "admin:users:position:assign",
  "admin:storefront:read",
      "admin:storefront:write",
      "admin:system-config:read",
      "admin:system-config:write",
      "shop:profile:read",
      "shop:password:write",
      "shop:orders:read",
      "shop:inquiry:write",
      "shop:wishlist:read",
      "shop:orders:processing:read",
      "shop:after-sales:read",
      "internal:work:targets:read",
      "internal:work:processing:read",
      "internal:maintenance:site:write",
      "internal:maintenance:permission:write",
      "internal:maintenance:position:write",
      "shop:products:read",
      "shop:storefront:read",
      "internal:system:config:read",
      "internal:system:config:write",
      "internal:security:audit:read",
      "internal:security:session:revoke",
      "internal:integration:manage",
      "admin:users:write",
      "admin:users:password:reset",
      "admin:users:delete",
      "crm:customer:read",
      "crm:customer:write",
      "crm:customer:assign",
      "website:content:read",
      "website:content:write",
      "website:navigation:write",
      "website:banner:write",
      "website:seo:write",
      "website:theme:write",
      "website:publish",
      "admin:products:create",
      "admin:products:delete",
      "merchandising:selection:read",
      "merchandising:selection:write",
      "catalog:pricing:write",
      "catalog:inventory:write",
      "catalog:translation:write",
      "sales:inquiry:read",
      "sales:inquiry:reply",
      "sales:quotation:create",
      "sales:quotation:approve",
      "sales:contract:write",
      "sales:sample:manage",
      "order:status:update",
      "order:split:merge",
      "procurement:purchase:write",
      "production:plan:write",
      "qa:inspection:write",
      "logistics:shipment:write",
      "logistics:tracking:read",
      "trade:customs:doc:write",
      "finance:invoice:read",
      "finance:invoice:write",
      "finance:payment:read",
      "finance:payment:write",
      "finance:refund:approve",
      "finance:reconciliation:write",
      "finance:tax:write",
      "marketing:campaign:read",
      "marketing:campaign:write",
      "marketing:coupon:write",
      "marketing:lead:export",
      "analytics:dashboard:read",
      "analytics:report:export",
      "support:ticket:read",
      "support:ticket:write",
      "support:return:approve",
      "support:complaint:handle",
      "office:announcement:write",
      "office:document:read",
      "office:document:write",
      "office:workflow:approve",
      "office:meeting:manage",
      "hr:attendance:manage",
      "hr:recruitment:manage",
      "hr:employee:read",
      "hr:employee:write"
    ];
